import { createApi } from '@reduxjs/toolkit/query/react';
import { CustomerBlackListedResponse } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const customerBlackList = createApi({
  reducerPath: 'customerBlackListApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['customer-blacklist', 'mark-customer-blacklist'],
  endpoints: (builder) => ({
    CheckBlackListStatus: builder.query({
      query: (mobile) => {
        return {
          url: `rsb/mobile/${mobile}/check`,
          method: 'GET',
        };
      },
      transformResponse: (response: CustomerBlackListedResponse) => response.data,
      providesTags: ['customer-blacklist'],
    }),
  }),
});

export const { useCheckBlackListStatusQuery } = customerBlackList;
